import '../scss/base.scss';

/* import from node-moldules */
import slick from "@accessible360/accessible-slick";
// import AOS from 'aos';

import { Accordion } from 'bootstrap';
// import { Dropdown } from 'bootstrap';
// import 'bootstrap/js/dist/dropdown';


const {
	__,
	_x
} = wp.i18n;

__('__', 'neighbourhoodalphabet');
_x('_x', '_x_context', 'neighbourhoodalphabet');


$(document).ready(function () {


	/******************************************************************/
	/* 					MENU & SCROLLING        					  */
	/******************************************************************/
	/*
	** for large menu to enlarge down and schrink up
	*/

	// AOS.init({
	// 	delay: 0,
	// 	mirror: false,
	// 	once: true,
	// 	throttleDelay: 20
	// });

	var $nav = $(".navbar");
	$nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height()/2 );
	console.log($nav.height());

	$(function () {
		$(document).scroll(function () {
			var $nav = $(".navbar");
			$nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height()/2 );
		});
	});

	'use strict';

	var c, currentScrollTop = 0,
	navbar = $('.navbar-global');

	if ( $(window).scrollTop() == 0 ) {
		navbar.addClass("scrolledbackUp");
	} else {
		navbar.addClass("scrollUp");
	}

	$(window).scroll(function () {
		if ( $(window).scrollTop() == 0 ) {
			navbar.removeClass("scrollUp");
			navbar.addClass("scrolledbackUp");
			$('.dropdown-menu').removeClass("show");
			$('.dropdown-toggle').removeClass("show");
		} else {
			navbar.addClass("scrollUp");
			navbar.removeClass("scrolledbackUp");
		}
	});




	/******************************************************************/
	/* 						 MENU BURGER          					  */
	/******************************************************************/

	var $navbar = $('.navbar-global');

	$('.menu-burger').click(function () {
		$('.na-dropdown-menu').toggleClass('na-dropped');
		$('body').toggleClass('noscroll');
		$(this).addClass('d-none').removeClass('d-block');
		$('.menu-close-cross').addClass('d-block');
		$('.menu-close-cross').removeClass('d-none');
	});

	$('.menu-close-cross').click(function () {
		$('.na-dropdown-menu').toggleClass('na-dropped');
		$('body').toggleClass('noscroll');
		$(this).removeClass('d-block').addClass('d-none');
		$('.menu-burger').toggleClass('d-none');
	});


	/******************************************************************/
	/* 						  CARROUSELS          					  */
	/******************************************************************/

	// $('.carousel-images').bind("mousemove", function () {


	// 	$('.next-button').stop(true,true).addClass('d-md-block', 1000);
	// 	$('.previous-button').addClass('d-md-block', 1000);

	// 	clearTimeout(moveTimer);
	// 	moveTimer = setTimeout(function(){
	// 		console.log("I stopped moving!");

	// 		$('.next-button').stop(true,true).removeClass('d-md-block', 1000);
	// 		$('.previous-button').removeClass('d-md-block', 1000);

	// 	},1000)

	// });

	var moveTimer;
	$(function() {
		$(".section-carousel-images").hover(
			function() {
				$('.carousel-images').bind("mousemove", function () {
					$('.next-button').stop().addClass('d-md-block', 1000);
					$('.previous-button').addClass('d-md-block', 1000);
					clearTimeout(moveTimer);
					moveTimer = setTimeout(function(){
						$('.next-button').stop().removeClass('d-md-block', 1000);
						$('.previous-button').removeClass('d-md-block', 1000);
					},1000)
				});
			}, 
			function() {
				$('.next-button').stop().removeClass('d-md-block', 1000);
				$('.previous-button').stop().removeClass('d-md-block', 1000);
			});
	});


	/*
	** Carrousel image solo on neighbourhood's single page
	*/
	if ($(".carousel-images").length > 0) {
		// $('.carousel-images').on('init', function (e, slick) {
		//   slick.$dots[0].querySelectorAll('button .slick-sr-only').forEach(function (buttonText) {
		//     buttonText.setAttribute("tabindex", "-1");
		//     return buttonText.innerText = buttonText.innerText.replace('Go to slide', __("Allez à l'image", 'fortytwo'));
		//   });
		// });
		$('.carousel-images').slick({
			dots: true,
			arrows: true,
			slidesToShow: 1,
			regionLabel: 'carrousel',
			infinite: true,
			autoplay: false,
			prevArrow: '<button class="previous-button is-control d-none">' +
			'  <span class="fas fa-angle-left" aria-hidden="true"></span>' +
			'  <span class="sr-only"><</span>' +
			'</button>',
			nextArrow: '<button class="next-button is-control d-none">' +
			'  <span class="fas fa-angle-right" aria-hidden="true"></span>' +
			'  <span class="sr-only">></span>' +
			'</button>'
		});

	}

	if ($(".carousel-letters").length > 0) {
		// $('.carousel-letters').on('init', function (e, slick) {
		//   slick.$dots[0].querySelectorAll('button .slick-sr-only').forEach(function (buttonText) {
		//     buttonText.setAttribute("tabindex", "-1");
		//     return buttonText.innerText = buttonText.innerText.replace('Go to slide', __("Allez à l'image", 'fortytwo'));
		//   });
		// });
		$('.carousel-letters').slick({
			dots: true,
			arrows: false,
			slidesToShow: 1,
			regionLabel: 'carrousel',
			infinite: true,
			autoplay: false,

			customPaging: function(slick,index) {
				var dotletter = slick.$slides.eq(index).find('img').attr('alt');
				return '<span class="dotitem">' + dotletter + ' </span>';
			},

			fade: true,
			fadeSpeed: 1000,
			prevArrow: '<button class="previous-button is-control d-none d-md-block">' +
			'  <span class="fas fa-angle-left" aria-hidden="true"></span>' +
			'  <span class="sr-only">Diapositive précédente</span>' +
			'</button>',
			nextArrow: '<button class="next-button is-control d-none d-md-block">' +
			'  <span class="fas fa-angle-right" aria-hidden="true"></span>' +
			'  <span class="sr-only">Diapositive suivante</span>' +
			'</button>'
		});
	}

	/*END*/
});